import Page from '../page';
import UiKitNavigation from '../navigation/ui-kit-navigation';

import UiKit from '../pages/ui-kit.vue';

const UiKitPages = [
    {
        path: '/ui-kit',
        // You could also have named views at the top
        components: {
            default: Page,
            'sidebar-nav': UiKitNavigation
        },
        children: [
            {
                path: '',
                component: UiKit
            }
        ]
    }
];

export default UiKitPages;



// WEBPACK FOOTER //
// ./demo/routes/ui-kit.js